module.exports = __webpack_public_path__ + "img/168-bulgaria.61fd590e.svg";